import httpRequest from '../../utils/request';

const list = async (params = {}) => {
  const res = await httpRequest.get('/purchases', { params });
  return res.data; // { items, total, page, limit, sum }
};

const create = async (data) => {
  const res = await httpRequest.post('/purchases', data);
  return res.data;
};

const getById = async (id) => {
  const res = await httpRequest.get(`/purchases/${id}`);
  return res.data;
};

const update = async (id, data) => {
  const res = await httpRequest.put(`/purchases/${id}`, data);
  return res.data;
};

const remove = async (id) => {
  const res = await httpRequest.delete(`/purchases/${id}`);
  return res.data;
};

const addPayment = async (id, data) => {
  const res = await httpRequest.post(`/purchases/${id}/payments`, data);
  return res.data;
};

// Reporte IVA compras (JSON)
const getIvaPurchasesReport = async ({ from, to }) => {
  const response = await httpRequest.get('/purchases/iva-purchases', { params: { from, to, format: 'json' } });
  return response.data;
};

// Descargar reporte IVA compras en XLSX
const downloadIvaPurchasesReport = async ({ from, to }) => {
  const response = await httpRequest.get('/purchases/iva-purchases', { params: { from, to, format: 'xlsx' }, responseType: 'blob' });
  return response;
};

const purchaseService = { list, create, getById, update, remove, addPayment };
purchaseService.getIvaPurchasesReport = getIvaPurchasesReport;
purchaseService.downloadIvaPurchasesReport = downloadIvaPurchasesReport;
export default purchaseService;
